/* Next10 — bolinhas e estado das setas da vitrine (.n10-vitrine).
   Acopla-se ao <slider-component> do Dawn (global.js): lê totalPages /
   sliderItemOffset e escuta o evento slideChanged que ele já dispara.
   Bolinhas iguais às do slick do site antigo: uma por posição de rolagem,
   ativa preta, inativas a 25%. */
(function () {
  const SELECTOR = '.n10-vitrine slider-component';

  function limpar(slider) {
    const nav = slider.querySelector('.n10-vitrine__nav');
    if (nav) nav.innerHTML = '';
    delete slider.dataset.n10Dots;
  }

  function buildDots(slider) {
    if (slider.dataset.n10Dots === 'ready') return;
    // O elemento pode ainda não ter sido atualizado pelo customElements.
    if (typeof slider.totalPages === 'undefined') return;

    const nav = slider.querySelector('.n10-vitrine__nav');
    if (!nav) return;

    slider.dataset.n10Dots = 'ready';

    const total = slider.totalPages;
    const estatico = !total || total < 2;
    slider.classList.toggle('n10-vitrine__slider--static', estatico);
    if (estatico) return;

    const dots = document.createElement('div');
    dots.className = 'n10-dots';
    dots.setAttribute('role', 'tablist');

    for (let i = 0; i < total; i++) {
      const dot = document.createElement('button');
      dot.type = 'button';
      dot.className = 'n10-dots__dot' + (i === 0 ? ' is-active' : '');
      dot.setAttribute('role', 'tab');
      dot.setAttribute('aria-label', `${i + 1} / ${total}`);
      dot.setAttribute('aria-selected', i === 0 ? 'true' : 'false');
      dot.addEventListener('click', () => {
        slider.slider.scrollTo({ left: i * slider.sliderItemOffset, behavior: 'smooth' });
      });
      dots.appendChild(dot);
    }

    nav.appendChild(dots);

    const sync = (page) => {
      dots.querySelectorAll('.n10-dots__dot').forEach((dot, i) => {
        const active = i === page - 1;
        dot.classList.toggle('is-active', active);
        dot.setAttribute('aria-selected', active ? 'true' : 'false');
      });
    };

    if (!slider.__n10DotsBound) {
      slider.__n10DotsBound = true;
      slider.addEventListener('slideChanged', (event) => sync(event.detail.currentPage));
    }
    sync(slider.currentPage || 1);
  }

  function init() {
    document.querySelectorAll(SELECTOR).forEach((slider) => {
      if (typeof slider.totalPages === 'undefined') {
        window.requestAnimationFrame(() => buildDots(slider));
      } else {
        buildDots(slider);
      }
    });
  }

  document.addEventListener('DOMContentLoaded', init);
  window.addEventListener('load', init);
  // Redesenha ao trocar de seção no editor de temas.
  document.addEventListener('shopify:section:load', init);

  // Ao mudar de faixa (1 → 3 → 4 cards por vez) o número de páginas muda.
  let resizeTimer = null;
  window.addEventListener('resize', () => {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(() => {
      document.querySelectorAll(SELECTOR).forEach((slider) => {
        const dots = slider.querySelectorAll('.n10-dots__dot').length;
        if (typeof slider.totalPages !== 'undefined' && dots !== (slider.totalPages || 0)) {
          limpar(slider);
          buildDots(slider);
        }
      });
    }, 150);
  });

  /* Blocos que chegam depois (ex.: <product-recommendations>, que busca o
     HTML por fetch) não passam por nenhum dos eventos acima. */
  let pending = null;
  const schedule = () => {
    if (pending) return;
    pending = window.requestAnimationFrame(() => {
      pending = null;
      init();
    });
  };

  const observe = () => {
    if (!document.body) return;
    new MutationObserver((mutations) => {
      for (const mutation of mutations) {
        for (const node of mutation.addedNodes) {
          if (node.nodeType !== 1) continue;
          if (node.matches?.('slider-component') || node.querySelector?.('slider-component')) {
            schedule();
            return;
          }
        }
      }
    }).observe(document.body, { childList: true, subtree: true });
  };

  if (document.body) {
    observe();
  } else {
    document.addEventListener('DOMContentLoaded', observe);
  }
})();
